module.exports = __webpack_public_path__ + "static/media/company9.80cf5926.png";